<div class="card-body">
    @if(acuse === null) {
        <div class="container">
             <div class="row">
                    <div class="col-12">
                        <p>No se encontró el folio</p>
                    </div>
                </div>
        </div>
    }
    @else {
        <div class="container">
            <div id="areaPrint">
                <div class="d-flex align-items-center justify-content-center">
                    <img src="assets/img/poderjudicial_grey.png" alt="Logo"
                        style="width: 143px; height: 137px; margin-bottom: 14px;">
                </div>
                <div class="row">
                    <div class="col-4">
                        <p>Autoridad que envía:</p>
                    </div>
                    <div class="col-8">
                        <p>{{acuse.autoridadEnvia}}</p>
                    </div>
                </div>
                <div class="row">
                    <div class="col-4">
                        <p>Número de folio:</p>
                    </div>
                    <div class="col-8">
                        <p>{{acuse.folioRecepcion}}</p>
                    </div>
                </div>
                <div class="row">
                    <div class="col-4">
                        <p>Fecha y hora de registro:</p>
                    </div>
                    <div class="col-8">
                        <p>
                            {{acuse.fechaRecepcionDT | date:'dd/MM/yyyy HH:mm aaa'}}
                        </p>
                    </div>
                </div>
                <div class="row">
                    <div class="col-4">
                        <p>Oficina de Correspondencia Común (OCC):</p>
                    </div>
                    <div class="col-8">
                        <p>
                            {{acuse.organoDestino}}
                        </p>
                    </div>
                </div>
                <div class="row">
                    <div class="col-4">
                        <p>Número de Boleta (OCC):</p>
                    </div>
                    <div class="col-8">
                        <p>
                            @if(acuse.boletaOCC === '0'){
                            Sin asignar
                            }
                            @else {
                            {{acuse.boletaOCC}}
                            }
                        </p>
                    </div>
                </div>
                <div class="row">
                    <div class="col-4">
                        <p>Órgano Juridiccional:</p>
                    </div>
                    <div class="col-8">
                        <p>
                            {{acuse.organoOrigen}}
                        </p>
                    </div>
                </div>
                <div class="row">
                    <div class="col-4">
                        <p>Tipo de Asunto:</p>
                    </div>
                    <div class="col-8">
                        <p>
                            @if(acuse.tipoAsunto === null){
                            Sin asignar
                            }
                            @else {
                            {{acuse.tipoAsunto}}
                            }
                        </p>
                    </div>
                </div>
                <div class="row">
                    <div class="col-4">
                        <p>Número de Expediente:</p>
                    </div>
                    <div class="col-8">
                        <p>
                            @if(acuse.numeroExpediente === '0'){
                            Sin Asignar
                            }
                            @else {
                            {{acuse.numeroExpediente}}
                            }
                        </p>
                    </div>
                </div>
            </div>
            <div class="row mt-3">
                <div class="col-sm-4">
                    <button type="button" (click)="printDemanda()" class="btn-search-promotion">
                        <i class="far fa-file-pdf"></i> Imprimir
                    </button>
                </div>
            </div>
            <!-- <table class="table_component">
        <thead>
            <th></th>
            <th></th>
        </thead>
        <tbody>
            <tr>
                <td>Número de folio</td>
                <td></td>
            </tr>
            <tr>
                <td>Fecha y hora de registro</td>
                <td></td>
            </tr>
        </tbody>
    </table> -->
    
        </div>
    }
</div>